import * as Models from '@models';

export const modelsMap = new Map<string, any>([
  ['users', Models.User],
  ['books', Models.Book],
  ['authors', Models.Author],
  ['search', Models.Search],
  ['search-results', Models.SearchResult],
]);
